/**
 * Lumiavera – Gallery Fix v2
 *
 * FIX 1: al cambio variante (desktop + mobile) la galleria naviga verso
 *   l'immagine della variante selezionata.
 *
 * FIX 2: al caricamento della pagina mostra sempre la prima foto
 *   (quella ambientata) ignorando la featured_media della variante default.
 *   Appena l'utente tocca/clicca un selettore di variante, il comportamento
 *   torna normale e ogni cambio aggiorna la galleria.
 *
 * Strategia v2:
 *   Invece di bloccare variant:change (che causava problemi su mobile),
 *   usiamo un approccio piu diretto:
 *   - Al DOMContentLoaded forziamo scroll a 0 sulla galleria
 *   - Sovrascriviamo temporaneamente carousel.select() con una versione
 *     che ignora la chiamata iniziale del tema al load
 *   - Dopo la prima interazione utente, ripristiniamo select() originale
 */

(function () {
  'use strict';

  function initGalleryFix() {
    document.querySelectorAll('product-gallery').forEach(function (gallery) {
      const formId = gallery.getAttribute('form');
      const form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      const carousels = Array.from(gallery.querySelectorAll('media-carousel'));
      if (!carousels.length) return;

      // Flag: utente ha interagito almeno una volta
      let interacted = false;

      // ----------------------------------------------------------------
      // FIX 2: blocca temporaneamente carousel.select() per il load iniziale
      // ----------------------------------------------------------------
      carousels.forEach(function (carousel) {
        const originalSelect = carousel.select.bind(carousel);

        // Sovrascrivi select: la prima chiamata (dal tema al connectedCallback
        // o all'init della variante default) viene ignorata.
        // Tutte le chiamate successive passano normalmente.
        let initCallDone = false;

        carousel.select = function (index, options) {
          if (!interacted && !initCallDone) {
            // Prima chiamata al load: ignora la navigazione verso la
            // featured_media della variante default, lascia lo slide 0
            initCallDone = true;
            return;
          }
          // Chiamate successive (utente ha interagito, o secondi cambi al load)
          return originalSelect(index, options);
        };

        // ----------------------------------------------------------------
        // FIX 2b: forza lo scroll fisico a 0 dopo l'init del tema
        // ----------------------------------------------------------------
        // Usiamo scrollTo direttamente per bypassare tutta la logica
        // del carousel e portare fisicamente la galleria al primo slide
        setTimeout(function () {
          carousel.scrollTo({ left: 0, behavior: 'auto' });
          // Aggiorna anche l'indice interno del carousel
          carousel._selectedIndex = 0;

          // Aggiorna page-dots
          gallery.querySelectorAll('page-dots button[aria-current]').forEach(function (btn, i) {
            btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          });
          // Aggiorna thumbnail
          gallery.querySelectorAll('.product-gallery__thumbnail').forEach(function (btn, i) {
            btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          });
        }, 50);
      });

      // ----------------------------------------------------------------
      // FIX 1: rileva interazione utente su qualsiasi selettore di variante
      // ----------------------------------------------------------------
      // Ascolta sia click (desktop/mobile tap) che change (dropdown)
      // sull'intera pagina prodotto, non solo su variant-picker,
      // per catturare tutti i tipi di selezione di Impact.
      const productEl = gallery.closest('.product') || document;

      function markInteracted() {
        if (!interacted) {
          interacted = true;
          // Ripristina select originale su tutti i carousel
          carousels.forEach(function (carousel) {
            // Rimuovi il wrapper: ora carousel.select punta di nuovo
            // al prototipo originale di ScrollCarousel
            delete carousel.select;
          });
        }
      }

      // Click su swatch, block selector, dropdown option
      productEl.addEventListener('click', function (e) {
        const target = e.target;
        if (
          target.closest('variant-picker') ||
          target.closest('variant-selects') ||
          target.closest('.variant-picker') ||
          target.closest('[data-option-position]')
        ) {
          markInteracted();
        }
      }, { passive: true, capture: true });

      // Change su select dropdown
      productEl.addEventListener('change', function (e) {
        if (
          e.target.closest('variant-picker') ||
          e.target.closest('variant-selects') ||
          e.target.tagName === 'SELECT'
        ) {
          markInteracted();
        }
      }, { capture: true });

      // Sicurezza: dopo 2 secondi, comunque abilita il comportamento normale
      // (evita blocchi in caso di edge case)
      setTimeout(markInteracted, 2000);
    });
  }

  // Esegui dopo DOMContentLoaded con doppio rAF per attendere
  // l'inizializzazione dei custom elements di Impact
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(initGalleryFix);
      });
    });
  } else {
    requestAnimationFrame(function () {
      requestAnimationFrame(initGalleryFix);
    });
  }
})();
